export type Todo = any // eslint-disable-line @typescript-eslint/no-explicit-any

export const DEFAULT_PAGE_SIZE = 20

export type PersistState<T> = (config: (set: Todo, get: Todo) => T, options: Todo) => (set: Todo, get: Todo) => T

export type Pagination = {
  page: number
  limit: number
  total: number
  totalPage: number
}

export type ListResponse<T> = {
  items: T[]
  pagination: Pagination
}

export enum DialogId {
  CREATE_NG_WORD = 'CREATE_NG_WORD',
  UPDATE_NG_WORD = 'UPDATE_NG_WORD',
  DELETE_NG_WORD = 'DELETE_NG_WORD',
  DETAIL_NG_WORD = 'DETAIL_NG_WORD',
  REVIEW_APPLICATION = 'REVIEW_APPLICATION',
  APPLICATION_DETAIL = 'APPLICATION_DETAIL',
  CREATE_SERVICE_PACKAGE = 'CREATE_SERVICE_PACKAGE',
  UPDATE_SERVICE_PACKAGE = 'UPDATE_SERVICE_PACKAGE',
  DELETE_SERVICE_PACKAGE = 'DELETE_SERVICE_PACKAGE',
  DETAIL_SERVICE_PACKAGE = 'DETAIL_SERVICE_PACKAGE',
  CATEGORY_REQUEST_DETAIL = 'CATEGORY_REQUEST_DETAIL',
  REVIEW_CATEGORY_REQUEST = 'REVIEW_CATEGORY_REQUEST',
  DETAIL_USER = 'DETAIL_USER',
  UPDATE_USER_ROLE = 'UPDATE_USER_ROLE',
  GRANT_USER_POINTS = 'GRANT_USER_POINTS',
  CREATE_SKILL = 'CREATE_SKILL',
  UPDATE_SKILL = 'UPDATE_SKILL',
  DELETE_SKILL = 'DELETE_SKILL',
  DETAIL_SKILL = 'DETAIL_SKILL',
  CREATE_SCHOOL = 'CREATE_SCHOOL',
  UPDATE_SCHOOL = 'UPDATE_SCHOOL',
  IMPORT_SCHOOLS = 'IMPORT_SCHOOLS',
}

export type DynamicDialogId = `${DialogId}_${string}`
